import { Component, OnInit } from '@angular/core';
import { ProductStorageService } from '../product-storage.service';
import { Message } from 'primeng/primeng';
import { GlobalDataService } from '../../../../services/global-data.service';
import { CellService } from '../../cells/cell.service';
import { CurrencyService } from '../../currencies/currency.service';
import { CategoryService } from '../../categories/category.service';

import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';


export interface Pagination {
      current_page?: number;
      first_item?: number; 
      first_page_url?: string;
      last_item?: number;
      last_page?: number; 
      last_page_url?: string;
      next_page_url?: string;
      per_page?: number;
      prev_page_url?: string;
      total?: number; 
    } 

@Component({
  selector: 'app-product-storage',
  templateUrl: './product-storage.component.html',
  styleUrls: ['./product-storage.component.css'],
  providers: [ 
    ProductStorageService, 
    CellService,
    CurrencyService,
    CategoryService
   ]
})

export class ProductStorageComponent implements OnInit {

  productStorage = Array();
  defectiveProductStotage: any;
  defectiveProductServer: any = [];
	loading: boolean = true;
  productStorageTransactionModal: boolean = false;

  defectiveModal:boolean=false;
  defectiveProductServerModal:boolean=false;
  defectiveProductServerLoading:boolean = false;
  selectedAvailable:boolean = false;
  loadingPanel:boolean = false;
  selectedProduct: any;
  selectedCell:string;
  pagination: Pagination;
  cells:any = [];
  currencies:any = [];
  selectedCurrency:any;
  retailPrice:any;
  display:boolean = false;
  msgs: Message[] = [];
  forCell: any = {sku: 0,product:"",cells:[], count: 0, store: {}};

  searchFilter: any = [];
  searchColumn: any = [];

  searchFilterDefective: any = [];
  searchColumnDefective: any = [];

  categoryList: any = [];
  categoryFetch: any = [];

  constructor(
              private productStorageService: ProductStorageService, 
              public global: GlobalDataService,
              private currencyService: CurrencyService,
              private categoryService: CategoryService,
              private cellService: CellService
              ) { }

  ngOnInit() {
    this.defectiveProductServerModal=false;
    this.fillSearchColumn();
    this.fillSearchColumnDefective();
    this.init();
    

    this.pagination = {  
      current_page: 1,
      per_page: 1,
      last_page: 1
    }

    this.loadProductStoragesByFilter();

        console.log(this.global.user);
        this.forCell.store = this.global.user['stores'];
        console.log('this.forCell.store');
        console.log(this.forCell.store);
        this.cellService.getCellByFilter([{name: 'store_id', value : this.forCell.store[0]['id']}]).subscribe(response=>{
                             this.cells=response['data'].map(function(value: any){return {label:value.name, value: value.id};});  
                       });
        this.currencyService.getCurrency().subscribe(response=>{
                                 this.currencies=response['data'].map(function(value: any){return {label:value.name, value: value.id};});  
                            });

  		
  }

  loadProductStoragesByFilter(filter=[],page: number = 1){
    this.loading = true;
    this.productStorageService.getProductStorageByFilter(filter,page).subscribe(response=>{ this.pagination = response['pagination'] || {current_page: 1,per_page: 1,last_page: 1};this.loading=false;this.productStorage=response['data'];console.log(response);})
  }  


  fillSearchColumn() {
    this.searchColumn=[];
    this.searchColumn.push({ label: "Код", value: { column: "sku", type: "textbox" } });
    this.searchColumn.push({ label: "Название", value: { column: "name", type: "textbox"} });
    this.searchColumn.push({ label: "Категория", value: { column: "category_id", type: "dropdown",value: this.categoryList } });
    this.searchColumn.push({ label: "Склад", value: { column: "store_id", type: "dropdown",value: this.global.user.stores.map(value => {
      return { label: value.name, value: { value: value.id, label: value.name } };
    }) } });
  }

  fillSearchColumnDefective(){
    this.searchColumn=[];
    this.searchColumn.push({ label: "Склад", value: { column: "store_id", type: "dropdown",value: this.global.user.stores.map(value => {
      return { label: value.name, value: { value: value.id, label: value.name } };
    }) } });
  }

  init(){
    this.categoryService.getCategory(1).subscribe(response=>{
      this.recarray(response['data'],'children',this);
       this.categoryList=this.categoryFetch.map(function(value: any){
                                    return {label:value.name, value: {label: value.name ,value: value.id}};
                               });  
        this.fillSearchColumn();
   });

  }
  setFilter(data){
    this.searchFilter=data;
    this.loadProductStoragesByFilter(this.searchFilter, 1);
  }

  setFilterDefective(data){
    this.searchFilterDefective=data;
    this.loadProductStoragesByFilter(this.searchFilterDefective, 1);
  }

  recarray(ar: any, searchfor: any,that: any) {
    ar.forEach(function(item: any,i: any,arr: any){
        if(item instanceof Object){
            if("children" in item){
               that.recarray(item['children'],searchfor,that)
            }
            that.categoryFetch.push(item);
        }
    });
  }


  show():void{
     this.productStorageTransactionModal = true;
  }

  edit():void{
     this.productStorageTransactionModal = true;
  }

  update(dt){
       dt.reset();
  }

  onRowSelect(event) {
     this.forCell = event.data;
     this.selectedCurrency =  this.forCell.currency &&  this.forCell.currency.id;
     this.retailPrice = this.forCell.retail_price;
     this.selectedCell = this.forCell.cell && this.forCell.cell.id; 
     this.selectedAvailable = this.forCell && this.forCell.available;
     console.log(event.data);
     this.display = true;
     console.log(this.forCell);
  }

  toggleDisplay(){
     this.display=!this.display;
  }
  onUpdateCell(){
     this.cellService.updateCell({store_id: this.forCell.store.id},"1").subscribe();
  }

  onUpdate(){
    let data = {
      retail_price: this.retailPrice,
      currency_id: this.selectedCurrency,
      available: this.selectedAvailable
    };

    if(this.selectedCell){
      data['cell_id'] = this.selectedCell;
    }
    this.loadingPanel = true;
    this.productStorageService.updateProductStorage(data,this.forCell.id).subscribe(response=>{
      this.loadProductStoragesByFilter(this.searchFilter,this.pagination.current_page); 
      this.loadingPanel = false;
      this.msgs=[];this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно изменено!"});
    });
 }

  onRowUnselect(event) {
     console.log(event);
      this.msgs = [];
      this.msgs.push({severity: 'info', summary: 'Car Unselected', detail: event.data.vin + ' - ' + event.data.brand});
  }

  onPaginate(event) {
    event.page=event.page+1
    this.pagination.current_page= event.page;
    this.loadProductStoragesByFilter(this.searchFilter,this.pagination.current_page);
}

onShowDefectiveModal(productStorage: any){
  this.defectiveProductStotage= productStorage;
  this.defectiveModal=true;
}

onDefectiveProduct(form: NgForm){
  let data ={
    product_id : this.defectiveProductStotage.product.id,
    store_id : this.defectiveProductStotage.store.id,
    count : form.value['count'],
    description : form.value['description']
  }
  this.productStorageService.defectiveProduct(data).subscribe(response=>{form.reset(); this.loadProductStoragesByFilter(this.searchFilter,this.pagination.current_page); this.defectiveModal=false;this.msgs=[]; this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно списано товар"});});
}

onDefectiveProductServerByFilter(filter=[],page: number = 1){
  this.defectiveProductServer=[];
  this.defectiveProductServerModal = true;
  this.defectiveProductServerLoading = true;
  this.productStorageService.getDefectiveProductByFilter(filter,page).subscribe(response=>{
    // this.pagination = response['pagination'] || {current_page: 1,per_page: 1,last_page: 1};
    this.defectiveProductServer=response['data'];
    this.defectiveProductServerLoading = false;
  });

}

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/product_storages/product-storage/product-storage.component.ts